import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Main = _resolveComponent("Main")!
  const _component_Content = _resolveComponent("Content")!
  const _component_Complete = _resolveComponent("Complete")!
  const _component_CommentWrite = _resolveComponent("CommentWrite")!

  return (!$setup.state.isStart)
    ? (_openBlock(), _createBlock(_component_Main, {
        key: 0,
        onStart: $setup.start
      }, null, 8, ["onStart"]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        ($setup.state.step > 0 && $setup.state.step < 4)
          ? (_openBlock(), _createBlock(_component_Content, {
              key: 0,
              onNext: $setup.next,
              onPrev: $setup.prev,
              step: $setup.state.step,
              value: $setup.state.currentData
            }, null, 8, ["onNext", "onPrev", "step", "value"]))
          : ($setup.state.step > 4)
            ? (_openBlock(), _createBlock(_component_Complete, {
                key: 1,
                onPrev: $setup.prev,
                onComplete: $setup.complete
              }, null, 8, ["onPrev", "onComplete"]))
            : ($setup.state.step === 4)
              ? (_openBlock(), _createBlock(_component_CommentWrite, {
                  key: 2,
                  onNext: $setup.next,
                  onPrev: $setup.prev,
                  value: $setup.eventData.myComment
                }, null, 8, ["onNext", "onPrev", "value"]))
              : _createCommentVNode("", true)
      ], 64))
}